import { supabase } from './init-db';

const AVATAR_BUCKET = 'avatars';
const SIGNED_URL_TTL_SECONDS = 60 * 60;
const STORAGE_PATH_PATTERNS = [
  /\/storage\/v1\/object\/(?:public|sign)\/avatars\/([^?]+)/i,
  /\/storage\/v1\/render\/image\/(?:public|sign)\/avatars\/([^?]+)/i,
];

export function isRemoteUrl(value) {
  return typeof value === 'string' && /^(https?:)?\/\//i.test(value);
}

export function extractAvatarObjectPath(value) {
  if (typeof value !== 'string' || !value) {
    return '';
  }

  if (!isRemoteUrl(value)) {
    return value;
  }

  for (const pattern of STORAGE_PATH_PATTERNS) {
    const match = value.match(pattern);
    if (match?.[1]) {
      return decodeURIComponent(match[1]);
    }
  }

  return '';
}

export async function resolveAvatarUrl(value) {
  if (!value) {
    return '';
  }

  const objectPath = extractAvatarObjectPath(value);

  if (!objectPath && isRemoteUrl(value)) {
    return value;
  }

  if (!supabase) {
    return '';
  }

  const { data, error } = await supabase.storage
    .from(AVATAR_BUCKET)
    .createSignedUrl(objectPath, SIGNED_URL_TTL_SECONDS);

  if (error) {
    throw error;
  }

  return data?.signedUrl || '';
}